import React from 'react'
import { Field } from 'redux-form'
import { PlainTextContainer } from 'shared/StyledComponents'

const PlainTextFieldComponent = ({ input: { value } }) => <PlainTextContainer>{value}</PlainTextContainer>

const PlainTextField = ({ name }) => <Field name={name} component={PlainTextFieldComponent} />

export default PlainTextField
